import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import classes from './FanollyContents.module.scss';
import arrowLong from '../../../assets/images/arrow-long.svg';
import Snaplark from './Snaplark/Snaplark';
import ConFanolly from './ConFanolly/ConFanolly';
import Sumofame from './Sumofame/Sumofame';

const FanollyContents = ({ contents, activeIndex, animEnd, setAnimEnd, setActiveIndex, onBack, className, style }) => {
  const rootClass = [classes.FanollyContents];
  if (className) rootClass.push(className);

  return (
    <div className={rootClass.join(' ')} style={{
      background: activeIndex === 0 ? 'linear-gradient(to Bottom, #237BFF, #4CC8FF' : (activeIndex !== 1 
      ? contents[activeIndex].colors[2]
      : 'none'),
      ...style
    }}>
      <div className={classes.Contents}>
        <div className={classes.Head}>
          <button className={classes.BackButton} onClick={onBack}>
            <img src={arrowLong} alt="Fanolly.com" className={classes.Logo} style={activeIndex === 1 ? {
              filter: 'invert(1)'
            }:{}} />
          </button>

          {contents.map((content, i) => {
            const styles = {
              color: contents[activeIndex].colors[1]
            };
            if (i === activeIndex) {
              styles.color = content.colors[activeIndex === 0 ? 3 : 0];
              styles.opacity = 1;
            }

            return (
              <h1 key={i} className={classes.Title} style={styles}
                onClick={()=> setActiveIndex(i)}
              >{content.name}</h1>
            );
          })}
        </div>

        <AnimatePresence exitBeforeEnter>
          <motion.div className={classes.Body}
            key={activeIndex}
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.5, opacity: 0, transition: { duration: 0.1 } }}
            onAnimationStart={()=> setAnimEnd(false)}
            onAnimationComplete={()=> setAnimEnd(true)}
          >
              {activeIndex === 0 && <Snaplark end={animEnd} colors={contents[activeIndex].colors} />}
              {activeIndex === 1 && <ConFanolly end={animEnd} colors={contents[activeIndex].colors} />}
              {activeIndex === 2 && <Sumofame end={animEnd} colors={contents[activeIndex].colors} />}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}

export default FanollyContents;